(function () {
  const root = document.querySelector('.es');
  if (!root) return;

  const isFr = root.dataset.locale === 'fr';
  const localePrefix = root.dataset.localePrefix || '';
  const t = (fr, en) => isFr ? fr : en;

  // === GA4 tracking ===
  const entryPath = (() => {
    try {
      const url = new URL(window.location.href);
      const src = url.searchParams.get('cfg_from') || url.searchParams.get('source');
      if (src) return src;
      const ref = document.referrer || '';
      if (!ref) return 'direct';
      if (ref.includes('/collections/')) return 'collection';
      if (ref.includes('/products/')) return 'pdp';
      if (ref.includes('/pages/notre-gamme')) return 'notre_gamme';
      if (ref.includes('/search')) return 'search';
      const u = new URL(ref);
      if (u.host === window.location.host && (u.pathname === '/' || u.pathname.match(/^\/(en|fr|de|es|it|pt)([-/]|$)/))) return 'homepage';
      return 'other';
    } catch (e) { return 'direct'; }
  })();
  const entryPlacement = (() => {
    const url = new URL(window.location.href);
    let placement = url.searchParams.get('cfg_place');
    try {
      const stored = JSON.parse(sessionStorage.getItem('scart_configurator_entry') || 'null');
      sessionStorage.removeItem('scart_configurator_entry');
      if (!placement && stored && stored.path === url.pathname && Date.now() - stored.at < 30000) {
        placement = stored.placement;
      }
    } catch (error) {}
    return placement || url.searchParams.get('cfg_from') || entryPath;
  })();
  function trackEvent(name, params) {
    const payload = Object.assign({ entry_path: entryPath, entry_placement: entryPlacement }, params || {});
    // window.gtag est posé par le canal Google de Shopify, APRÈS ce script : un event tiré
    // au chargement (configurator_start) était perdu dans ~1 session sur 4 (BigQuery, 04/09/2026).
    // On réessaie jusqu'à 10 s avant d'abandonner.
    const send = (tries) => {
      if (typeof window.gtag === 'function') { try { window.gtag('event', name, payload); } catch (e) {} return; }
      if (tries > 0) setTimeout(() => send(tries - 1), 250);
    };
    send(40);
    try { if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, payload)); } catch (e) {}
  }
  trackEvent('configurator_start', {});

  // Track quicksearch form submission (visitors who prefer free search over guided flow)
  const qsForm = document.querySelector('[data-quicksearch-form]');
  if (qsForm) {
    qsForm.addEventListener('submit', (e) => {
      const q = qsForm.querySelector('input[name="q"]').value.trim();
      trackEvent('configurator_quicksearch', { query: q });
    });
  }

  // Auto-focus the search input on details open so the user can type immediately
  const qsToggle = document.querySelector('.es-quicksearch-toggle');
  if (qsToggle) {
    qsToggle.addEventListener('toggle', () => {
      if (qsToggle.open) {
        const input = qsToggle.querySelector('.es-quicksearch-toggle__input');
        if (input) setTimeout(() => input.focus(), 50);
      }
    });
  }

  // === Catalog tree (Liquid-rendered) ===
  let TREE = { brands: [] };
  try {
    TREE = JSON.parse(document.getElementById('es-catalog').textContent.trim());
  } catch (e) {
    console.error('[es] catalog parse failed', e);
  }

  const CLASSIC = typeof window.ScartClassicCatalog === 'function'
    ? window.ScartClassicCatalog({
        t,
        images: {
          typeG: root.dataset.classicImageTypeG,
          turbo930: root.dataset.classicImage930,
          carrera964: root.dataset.classicImage964Carrera,
          turbo964: root.dataset.classicImage964Turbo,
          carrera993: root.dataset.classicImage993Carrera,
          turbo993: root.dataset.classicImage993Turbo
        },
        badges: {
          sc: root.dataset.classicBadgeSc,
          carrera: root.dataset.classicBadgeCarrera,
          turbo: root.dataset.classicBadgeTurbo
        }
      })
    : { families: {}, cars: {} };

  const CONFIG_DATA = window.SCART_CONFIGURATOR_DATA || { vehicles: [], families: [], familyMap: {} };
  const PRODUCTION_STATE = window.ScartConfiguratorProductionState || { families: {} };
  const PRODUCTION_FAMILY_IDS = new Set(Object.keys(PRODUCTION_STATE.families || {}));
  const LEGACY_FAMILY_IDS = new Set([
    'porsche-911-type-g',
    'porsche-911-930-turbo',
    'porsche-911-964-carrera',
    'porsche-911-964-turbo',
    'porsche-911-993-carrera',
    'porsche-911-993-turbo'
  ]);
  const CANONICAL_ALIASES = {
    'porsche-911-type-g-2-7': 'type-g-27-30',
    'porsche-911-sc-3-0': 'type-g-27-30',
    'porsche-911-carrera-3-2': 'type-g-32',
    'porsche-911-930-turbo': '930',
    'porsche-911-964-carrera': '964-carrera',
    'porsche-911-964-turbo': '964-turbo',
    'porsche-911-993-carrera': '993-carrera',
    'porsche-911-993-turbo': '993-turbo'
  };

  function resolveConfiguratorAsset(file) {
    if (!file) return '';
    return (root.dataset.assetBaseUrl || '/cdn/shop/t/1/assets/') + file;
  }

  function publicFamily(familyId) {
    return CONFIG_DATA.familyMap && CONFIG_DATA.familyMap[familyId];
  }

  function publicVehicle(vehicleId) {
    return CONFIG_DATA.vehicleMap && CONFIG_DATA.vehicleMap[vehicleId];
  }

  function familyVersion(familyId) {
    const family = publicFamily(familyId);
    if (!family) return null;
    const vehicles = (family.vehicleIds || []).map(publicVehicle).filter(Boolean);
    if (!vehicles.length) return null;
    const primary = vehicles.find((vehicle) => vehicle.hasPseQuestion)
      || vehicles.find((vehicle) => !/-pse$/.test(vehicle.id))
      || vehicles[0];
    const pse = primary.hasPseQuestion
      ? vehicles.find((vehicle) => vehicle.id !== primary.id && /-pse$/.test(vehicle.id))
      : null;
    return {
      id: CANONICAL_ALIASES[primary.id] || primary.id,
      pseCar: pse ? (CANONICAL_ALIASES[pse.id] || pse.id) : '',
      label: family.name || primary.shortName || primary.displayName,
      meta: [primary.period, primary.architecture].filter(Boolean).join(' · '),
      badge: resolveConfiguratorAsset(primary.logoAsset),
      collection: primary.generationId || primary.modelId,
      familyId
    };
  }

  function registerPublicCars() {
    PRODUCTION_FAMILY_IDS.forEach((familyId) => {
      if (LEGACY_FAMILY_IDS.has(familyId)) return;
      const family = publicFamily(familyId);
      if (!family) return;
      (family.vehicleIds || []).forEach((vehicleId) => {
        const vehicle = publicVehicle(vehicleId);
        const carId = CANONICAL_ALIASES[vehicleId] || vehicleId;
        if (!vehicle || CLASSIC.cars[carId]) return;
        CLASSIC.cars[carId] = {
          id: carId,
          name: vehicle.displayName,
          description: vehicle.description,
          architecture: vehicle.architecture,
          caption: vehicle.caption,
          image: resolveConfiguratorAsset(family.drawingAsset || vehicle.drawingAsset),
          alt: `${vehicle.displayName} — vue de dessous`,
          zones: (vehicle.zones || []).map((zone) => ({
            ...zone,
            rects: (zone.rects || []).map((rect) => rect.map(Number))
          })),
          accessories: vehicle.accessories || []
        };
        const override = window.ScartClassicZoneOverrides
          && window.ScartClassicZoneOverrides[carId];
        if (override) {
          CLASSIC.cars[carId].zones.forEach((zone) => {
            if (Array.isArray(override[zone.id])) {
              zone.rects = override[zone.id].map((rect) => rect.map(Number));
            }
          });
        }
      });
    });
  }

  // Helpers
  function findBrand(handle) { return TREE.brands.find(b => b.handle === handle); }
  function findModel(brandHandle, modelHandle) {
    const b = findBrand(brandHandle);
    return b ? b.models.find(m => m.handle === modelHandle) : null;
  }
  function findGen(brandHandle, modelHandle, genHandle) {
    const m = findModel(brandHandle, modelHandle);
    return m ? (m.generations || []).find(g => g.handle === genHandle) : null;
  }

  function vehicleBrandHandle(vehicle) {
    const brand = TREE.brands.find((item) => item.label.toLowerCase() === String(vehicle.brand || '').toLowerCase());
    return brand ? brand.handle : String(vehicle.brand || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  }

  function generationRouteHandle(vehicle) {
    // La collection 997.1 porte le handle historique "997" dans l'arbre public.
    if (vehicleBrandHandle(vehicle) === 'porsche' && vehicle.modelId === '911' && vehicle.generationId === '997-1') return '997';
    return vehicle.generationId;
  }

  function ensurePublishedRoutesInTree() {
    PRODUCTION_FAMILY_IDS.forEach((familyId) => {
      if (LEGACY_FAMILY_IDS.has(familyId)) return;
      const family = publicFamily(familyId);
      const vehicle = family && publicVehicle((family.vehicleIds || [])[0]);
      if (!vehicle) return;
      const brandHandle = vehicleBrandHandle(vehicle);
      let brand = TREE.brands.find((item) => item.handle === brandHandle);
      if (!brand) {
        brand = { handle: brandHandle, label: vehicle.brand, image: null, models: [] };
        TREE.brands.push(brand);
      }
      let model = (brand.models || []).find((item) => item.handle === vehicle.modelId);
      if (!model) {
        model = { handle: vehicle.modelId, label: vehicle.model, image: null, generations: [] };
        brand.models.push(model);
      }
      const generationId = generationRouteHandle(vehicle);
      const needsGeneration = Boolean(generationId && generationId !== vehicle.modelId && (model.generations || []).length);
      if (needsGeneration && !model.generations.some((item) => item.handle === generationId)) {
        model.generations.push({
          handle: generationId,
          label: vehicle.generationLabel || vehicle.generation,
          image: null
        });
      }
    });
  }

  function promotedFamiliesForSelection(brandHandle, modelHandle, generationHandle) {
    return Array.from(PRODUCTION_FAMILY_IDS)
      .filter((familyId) => !LEGACY_FAMILY_IDS.has(familyId))
      .map((familyId) => publicFamily(familyId))
      .filter(Boolean)
      .filter((family) => (family.vehicleIds || []).some((vehicleId) => {
        const vehicle = publicVehicle(vehicleId);
        if (!vehicle || vehicleBrandHandle(vehicle) !== brandHandle || vehicle.modelId !== modelHandle) return false;
        return generationHandle ? generationRouteHandle(vehicle) === generationHandle : true;
      }));
  }

  function selectPublishedVersion(version) {
    if (!version) return;
    state.generation = version.collection || state.generation;
    state.classicZone = null;
    if (version.pseCar) {
      state.pendingPseChoice = {
        withoutPse: version.id,
        withPse: version.pseCar,
        label: version.label
      };
      transitionTo('pse', { direction: 'forward' });
      return;
    }
    state.classicCar = version.id;
    state.pendingPseChoice = null;
    transitionTo('piece', { direction: 'forward', beforeShow: renderClassicCar });
  }

  function activatePublishedSelection(brandHandle, modelHandle, generationHandle) {
    const families = promotedFamiliesForSelection(brandHandle, modelHandle, generationHandle);
    if (!families.length) return false;
    const versions = families.map((family) => familyVersion(family.id)).filter(Boolean);
    if (!versions.length) return false;
    const groupId = `published:${brandHandle}:${modelHandle}:${generationHandle || 'model'}`;
    CLASSIC.families[groupId] = {
      label: generationHandle || modelHandle,
      versions
    };
    state.classicFamily = groupId;
    state.classicCar = null;
    if (versions.length === 1) selectPublishedVersion(versions[0]);
    else {
      transitionTo('classic-version', { direction: 'forward', beforeShow: renderClassicVersionGrid });
    }
    return true;
  }

  registerPublicCars();
  ensurePublishedRoutesInTree();

  // Generation handles that fall into the "Riva" (older) zone - heuristic.
  // Default: anything else (996+, Boxster 986+, Ferrari, etc.) → Ultima zone.
  const RIVA_GENS = new Set([
    '911-type-f-1', '911-2-7l-3-0l-type-g', '911-type-g',
    '964', '993',
    'porsche-912-classic', 'porsche-912e',
    '914', '924', '928', '944', '968'
  ]);

  // === State ===
  const state = {
    brand: null,        // handle
    model: null,        // handle
    generation: null,   // handle (or null for models without gen)
    classicFamily: null,
    classicCar: null,
    pendingPseChoice: null,
    classicZone: null,
    classicFilter: null,
    sound: null,        // 'sport' | 'super_sound'
    valves: null        // 'oui' | 'non' | 'peu_importe'
  };
  let activeScreen = 'brand';

  function $screen(name) { return root.querySelector(`[data-screen="${name}"]`); }

  /* Type G : la ligne comprend un pre-silencieux ET un silencieux, d'ou une etape
     "que voulez-vous changer" et un choix de piece reelle plutot que de categorie. */
  function isTypeG() {
    var g = (state.generation || '') + ' ' + (state.model || '');
    return /type[-_\s]*g|2[.,]7|3[.,]0|3[.,]2/i.test(g);
  }

  function isClassic() {
    return Boolean(state.classicFamily && state.classicCar && CLASSIC.cars[state.classicCar]);
  }


  const SCREEN_ORDER = [
    'brand',
    'model',
    'generation',
    'classic-version',
    'pse',
    'piece',
    'sound',
    'valves',
    'result'
  ];

  let transitionTimer = null;
  let stageTransitionTimer = null;

  function transitionTo(name, opts) {
    opts = opts || {};
    if (activeScreen === name && !opts.force) return;

    root.classList.toggle('is-in-journey', name !== 'brand');

    const next = $screen(name);
    if (!next) return;

    const stage = root.querySelector('.es__stage');
    const cur = root.querySelector('.es__screen.is-active');
    const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Determine direction
    let direction = opts.direction;
    if (!direction) {
      const curIdx = SCREEN_ORDER.indexOf(activeScreen);
      const nextIdx = SCREEN_ORDER.indexOf(name);
      direction = (nextIdx !== -1 && curIdx !== -1 && nextIdx < curIdx) ? 'backward' : 'forward';
    }

    // Cancel any in-flight transition
    if (transitionTimer) {
      clearTimeout(transitionTimer);
      transitionTimer = null;
    }
    if (stageTransitionTimer) {
      clearTimeout(stageTransitionTimer);
      stageTransitionTimer = null;
    }

    // Clean up any previously leaving screens immediately
    root.querySelectorAll('.es__screen.is-leaving').forEach((el) => {
      el.classList.remove('is-leaving', 'is-leaving-forward', 'is-leaving-backward', 'is-active');
      el.hidden = true;
    });

    // If initial load or reduced motion requested, switch immediately without animation
    if (!cur || opts.immediate || prefersReducedMotion) {
      if (cur) {
        cur.classList.remove('is-active', 'is-entering-forward', 'is-entering-backward', 'is-leaving', 'is-leaving-forward', 'is-leaving-backward');
        cur.hidden = true;
      }
      if (stage) {
        stage.style.height = '';
        stage.style.transition = '';
        stage.style.overflow = '';
      }
      if (opts.beforeShow) opts.beforeShow();
      next.hidden = false;
      next.classList.remove('is-entering-forward', 'is-entering-backward', 'is-leaving', 'is-leaving-forward', 'is-leaving-backward');
      next.classList.add('is-active');
      activeScreen = name;
      updateEchoes();
      updateBreadcrumb();
      if (name === 'sound') updateListenLink();
      return;
    }

    // Populate target screen DOM synchronously so elements are ready
    if (opts.beforeShow) opts.beforeShow();

    // Measure starting height
    const startHeight = stage ? Math.ceil(stage.getBoundingClientRect().height) : 0;
    if (stage && startHeight > 0) {
      stage.style.height = `${startHeight}px`;
      stage.style.overflow = 'hidden';
    }

    // Exit animation on current screen
    cur.classList.remove('is-entering-forward', 'is-entering-backward');
    cur.classList.add('is-leaving', direction === 'backward' ? 'is-leaving-backward' : 'is-leaving-forward');

    transitionTimer = setTimeout(() => {
      cur.classList.remove('is-active', 'is-leaving', 'is-leaving-forward', 'is-leaving-backward');
      cur.hidden = true;

      // Clear any picked card states
      root.querySelectorAll('.es__card.is-picked').forEach((el) => el.classList.remove('is-picked'));

      next.hidden = false;
      next.classList.remove('is-leaving', 'is-leaving-forward', 'is-leaving-backward');
      next.classList.add('is-active', direction === 'backward' ? 'is-entering-backward' : 'is-entering-forward');
      activeScreen = name;
      updateEchoes();
      updateBreadcrumb();
      if (name === 'sound') updateListenLink();

      if (stage && startHeight > 0) {
        // Measure target natural height
        const targetHeight = Math.ceil(next.offsetHeight || next.getBoundingClientRect().height);
        if (targetHeight > 0 && Math.abs(targetHeight - startHeight) > 3) {
          stage.style.transition = 'height 0.22s cubic-bezier(0.2, 0.8, 0.2, 1)';
          stage.style.height = `${targetHeight}px`;
        } else {
          stage.style.height = '';
          stage.style.transition = '';
          stage.style.overflow = '';
        }

        stageTransitionTimer = setTimeout(() => {
          if (stage) {
            stage.style.height = '';
            stage.style.transition = '';
            stage.style.overflow = '';
          }
          next.classList.remove('is-entering-forward', 'is-entering-backward');
        }, 230);
      } else {
        stageTransitionTimer = setTimeout(() => {
          next.classList.remove('is-entering-forward', 'is-entering-backward');
        }, 210);
      }
    }, 80);
  }

  function updateListenLink() {
    const link = root.querySelector('[data-es-listen]');
    if (!link) return;
    const leaf = state.generation || state.model || '';
    const ret = '/pages/configurateur' + (leaf ? '?collection=' + encodeURIComponent(leaf) : '');
    let href = '/pages/sound-library';
    const params = [];
    if (leaf) params.push('gen=' + encodeURIComponent(leaf));
    params.push('return=' + encodeURIComponent(ret));
    href += '?' + params.join('&');
    link.setAttribute('href', href);
  }

  // === Render: card grids ===
  function imgHtml(image, alt) {
    if (image) return `<span class="es__card-image"><img src="${image}" alt="${alt || ''}" loading="lazy"></span>`;
    return `<span class="es__card-image es__card-image--empty"></span>`;
  }

  function renderBrandGrid() {
    const grid = root.querySelector('[data-grid="brand"]');
    grid.innerHTML = '';
    for (const b of TREE.brands) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'es__card es__card--brand';
      btn.dataset.pick = 'brand';
      btn.dataset.value = b.handle;
      btn.dataset.label = b.label;
      btn.innerHTML = imgHtml(b.image, b.label) + `<span class="es__card-label">${b.label}</span>`;
      grid.appendChild(btn);
    }
  }

  function renderModelGrid() {
    const grid = root.querySelector('[data-grid="model"]');
    grid.innerHTML = '';
    const brand = findBrand(state.brand);
    if (!brand) return;
    for (const m of brand.models) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'es__card es__card--model';
      btn.dataset.pick = 'model';
      btn.dataset.value = m.handle;
      btn.dataset.label = m.label;
      btn.innerHTML = imgHtml(m.image, m.label) + `<span class="es__card-label">${m.label}</span>`;
      grid.appendChild(btn);
    }
  }

  function renderGenerationGrid() {
    const grid = root.querySelector('[data-grid="generation"]');
    grid.innerHTML = '';
    const model = findModel(state.brand, state.model);
    if (!model || !model.generations || !model.generations.length) {
      // Skip to sound
      state.generation = null;
      transitionTo('sound');
      return;
    }
    const classicBySource = {
      '911-2-7l-3-0l-type-g': 'classic-type-g',
      '911-type-g': 'classic-type-g',
      '964': 'classic-964',
      '993': 'classic-993'
    };
    const renderedClassic = new Set();
    for (const g of model.generations) {
      const familyId = state.brand === 'porsche' && state.model === '911' ? classicBySource[g.handle] : null;
      if (familyId) {
        if (renderedClassic.has(familyId)) continue;
        renderedClassic.add(familyId);
        const family = CLASSIC.families[familyId];
        if (!family) continue;
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'es__card es__card--gen';
        btn.dataset.pick = 'classic-family';
        btn.dataset.value = familyId;
        btn.dataset.label = family.label;
        btn.innerHTML = imgHtml(g.image, family.label) + `<span class="es__card-label">${family.label}</span>`;
        grid.appendChild(btn);
        continue;
      }
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'es__card es__card--gen';
      btn.dataset.pick = 'generation';
      btn.dataset.value = g.handle;
      btn.dataset.label = g.label;
      btn.innerHTML = imgHtml(g.image, g.label) + `<span class="es__card-label">${g.label}</span>`;
      grid.appendChild(btn);
    }
  }

  function renderClassicVersionGrid() {
    const family = CLASSIC.families[state.classicFamily];
    const grid = root.querySelector('[data-grid="classic-version"]');
    const label = root.querySelector('[data-classic-family-label]');
    if (!family || !grid) return;
    grid.innerHTML = '';
    if (label) label.textContent = family.label;
    family.versions.forEach((version) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'es__card es__classic-version-card';
      btn.dataset.pick = 'classic-version';
      btn.dataset.value = version.id;
      btn.dataset.label = version.label;
      btn.innerHTML = `
        <span class="es__classic-version-media">${version.badge ? `<img src="${version.badge}" alt="" loading="lazy">` : '<i>SCART</i>'}</span>
        <span class="es__classic-version-label"><strong>${version.label}</strong><small>${version.meta || ''}</small><i aria-hidden="true">→</i></span>`;
      grid.appendChild(btn);
    });
  }

  // === Echoes & breadcrumb ===
  function updateEchoes() {
    const brand = findBrand(state.brand);
    const model = findModel(state.brand, state.model);
    root.querySelectorAll('[data-echo="brand"]').forEach(el => el.textContent = brand ? brand.label : '');
    root.querySelectorAll('[data-echo="model"]').forEach(el => el.textContent = model ? model.label : '');
  }

  function updateBreadcrumb() {
    const bc = root.querySelector('[data-bc]');
    const list = bc.querySelector('.es__bc-list');
    list.innerHTML = '';
    const steps = [];
    const brand = findBrand(state.brand);
    const model = findModel(state.brand, state.model);
    const gen = findGen(state.brand, state.model, state.generation);
    if (brand) steps.push({ key: 'brand', label: brand.label });
    if (model) steps.push({ key: 'model', label: model.label });
    if (state.classicFamily && CLASSIC.families[state.classicFamily]) {
      steps.push({ key: 'generation', label: CLASSIC.families[state.classicFamily].label });
      if (state.classicCar && CLASSIC.cars[state.classicCar]) {
        steps.push({ key: 'classic-version', label: CLASSIC.cars[state.classicCar].name.replace('Porsche 911 ', '') });
      }
      if (state.classicZone) steps.push({ key: 'piece', label: state.classicZone.n });
    } else if (gen) {
      steps.push({ key: 'generation', label: gen.label });
    }
    if (!isClassic() && state.piece) steps.push({ key: 'piece', label: state.pieceLabel || state.piece });
    if (state.sound) steps.push({ key: 'sound', label: state.sound === 'super_sound' ? 'Super Sound' : 'Sport' });
    if (state.valves) {
      const v = state.valves === 'oui' ? t('Avec valves', 'With valves')
              : state.valves === 'non' ? t('Sans valves', 'Without valves')
              : t('Valves : peu importe', 'Valves: any');
      steps.push({ key: 'valves', label: v });
    }
    if (!steps.length) { bc.hidden = true; return; }
    bc.hidden = false;
    steps.forEach((s, i) => {
      const li = document.createElement('li');
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'es__bc-chip';
      btn.textContent = s.label;
      btn.addEventListener('click', () => jumpBack(s.key));
      li.appendChild(btn);
      if (i < steps.length - 1) {
        const sep = document.createElement('span');
        sep.className = 'es__bc-sep';
        sep.textContent = '›';
        li.appendChild(sep);
      }
      list.appendChild(li);
    });
  }

  function clearAvailabilityClasses() {
    root.querySelectorAll('.es__card.is-unavailable').forEach(el => el.classList.remove('is-unavailable'));
  }

  function jumpBack(key) {
    if (key === 'brand' || key === 'model') {
      const selectedFamily = state.classicFamily;
      const nextScreen = key === 'brand' ? 'model'
        : (findModel(state.brand, state.model)?.generations || []).length ? 'generation'
        : selectedFamily ? 'classic-version' : 'sound';
      if (key === 'brand') state.model = null;
      state.generation = null;
      state.classicFamily = nextScreen === 'classic-version' ? selectedFamily : null;
      state.classicCar = null;
      state.classicZone = null;
      state.pendingPseChoice = null;
      state.piece = null;
      state.pieceLabel = '';
      state.sound = null;
      state.valves = null;
      state.pickedHandle = null;
      setClassicQuery('');
      leafCache = { handle: null, products: null, availability: null };
      clearAvailabilityClasses();
      transitionTo(nextScreen, {
        direction: 'backward',
        beforeShow: nextScreen === 'model' ? renderModelGrid
          : nextScreen === 'generation' ? renderGenerationGrid
          : nextScreen === 'classic-version' ? renderClassicVersionGrid : undefined
      });
      return;
    }
    if (state.classicFamily) {
      if (key === 'generation') {
        state.classicCar = null;
        state.classicZone = null;
        state.pendingPseChoice = null;
        setClassicQuery('');
        transitionTo('classic-version', { direction: 'backward', beforeShow: renderClassicVersionGrid });
        return;
      }
      if (key === 'classic-version') {
        state.classicCar = null;
        state.classicZone = null;
        state.generation = null;
        setClassicQuery('');
        transitionTo('classic-version', { direction: 'backward', beforeShow: renderClassicVersionGrid });
        return;
      }
      if (key === 'piece') {
        closeClassicResults();
        return;
      }
    }
    const order = isTypeG() ? ['brand', 'model', 'generation', 'piece', 'valves', 'sound'] : ['brand', 'model', 'generation', 'sound', 'valves'];
    const idx = order.indexOf(key);
    if (idx === -1) return;
    if (idx < 1) state.model = null;
    if (idx < 2) state.generation = null;
    if (idx < 3) state.sound = null;
    if (idx < 4) state.valves = null;
    // Invalidate leaf cache if leaf identity changes
    if (idx < 3) {
      leafCache = { handle: null, products: null, availability: null };
      clearAvailabilityClasses();
    }
    transitionTo(key, {
      direction: 'backward',
      beforeShow: () => {
        if (key === 'model') renderModelGrid();
        if (key === 'generation') renderGenerationGrid();
      }
    });
  }

  function restart() {
    state.pickedHandle = null; state.piece = null; state.pieceLabel = '';
    trackEvent('configurator_restart', {
      from: { brand: state.brand, model: state.model, generation: state.generation, sound: state.sound, valves: state.valves }
    });
    Object.assign(state, {
      brand: null, model: null, generation: null,
      classicFamily: null, classicCar: null, classicZone: null, classicFilter: null,
      pendingPseChoice: null,
      sound: null, valves: null
    });
    setClassicQuery('');
    leafCache = { handle: null, products: null, availability: null };
    clearAvailabilityClasses();
    updateSoundLabels();
    transitionTo('brand', {
      direction: 'backward',
      beforeShow: renderBrandGrid
    });
  }

  // === Porsche classiques: versions, schémas et références exactes ===
  const classicProductCache = new Map();

  function classicElements() {
    return {
      heading: root.querySelector('[data-classic-heading]'),
      description: root.querySelector('[data-classic-description]'),
      architecture: root.querySelector('[data-classic-architecture]'),
      diagramImg: root.querySelector('[data-classic-diagram-img]'),
      diagrams: root.querySelectorAll('[data-classic-diagram]'),
      zones: root.querySelector('[data-classic-zones]'),
      legend: root.querySelector('[data-classic-legend]'),
      caption: root.querySelector('[data-classic-caption]'),
      accessories: root.querySelector('[data-classic-accessories]'),
      accessoriesGrid: root.querySelector('[data-classic-accessories-grid]'),
      results: root.querySelector('[data-classic-results]'),
      resultsTitle: root.querySelector('[data-classic-results-title]'),
      resultsDescription: root.querySelector('[data-classic-results-description]'),
      filters: root.querySelector('[data-classic-filters]'),
      count: root.querySelector('[data-classic-count]'),
      products: root.querySelector('[data-classic-products]')
    };
  }

  function classicVersion(versionId) {
    for (const family of Object.values(CLASSIC.families)) {
      const version = family.versions.find((item) => item.id === versionId);
      if (version) return version;
    }
    return null;
  }

  function setClassicQuery(carId) {
    try {
      const url = new URL(window.location.href);
      if (carId) url.searchParams.set('car', carId);
      else url.searchParams.delete('car');
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
  }

  function setClassicHot(zoneId, active) {
    root.querySelectorAll(`[data-classic-zone="${zoneId}"]`).forEach((item) => {
      item.classList.toggle('is-hot', active);
    });
  }

  function renderClassicCar() {
    const car = CLASSIC.cars[state.classicCar];
    const els = classicElements();
    if (!car || !els.zones || !els.legend) return;
    els.heading.textContent = car.name;
    els.description.textContent = car.description;
    els.architecture.textContent = car.architecture;
    els.caption.textContent = car.caption;
    const diagramId = state.classicCar.indexOf('type-g-') === 0 ? 'type-g' : state.classicCar;
    const legacyDiagram = Array.from(els.diagrams).find((image) => image.dataset.classicDiagram === diagramId);
    if (car.image && !legacyDiagram && els.diagramImg) {
      els.diagramImg.src = car.image;
      els.diagramImg.alt = car.alt || car.name;
      els.diagramImg.hidden = false;
      els.diagrams.forEach((image) => { image.hidden = true; });
    } else {
      if (els.diagramImg) els.diagramImg.hidden = true;
      els.diagrams.forEach((image) => { image.hidden = image !== legacyDiagram; });
    }
    els.zones.innerHTML = '';
    els.legend.innerHTML = '';
    closeClassicResults();

    car.zones.forEach((zone) => {
      zone.rects.forEach((rect) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'es__classic-zone';
        button.dataset.classicZone = zone.id;
        button.setAttribute('aria-label', zone.n);
        button.style.setProperty('--left', `${rect[0]}%`);
        button.style.setProperty('--top', `${rect[1]}%`);
        button.style.setProperty('--width', `${rect[2]}%`);
        button.style.setProperty('--height', `${rect[3]}%`);
        button.addEventListener('mouseenter', () => setClassicHot(zone.id, true));
        button.addEventListener('mouseleave', () => setClassicHot(zone.id, false));
        button.addEventListener('focus', () => setClassicHot(zone.id, true));
        button.addEventListener('blur', () => setClassicHot(zone.id, false));
        button.addEventListener('click', () => selectClassicZone(zone));
        els.zones.appendChild(button);
      });

      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'es__classic-legend-card';
      card.dataset.classicZone = zone.id;
      card.innerHTML = `<span><strong>${zone.n}</strong><small>${zone.d}</small></span><i aria-hidden="true">›</i>`;
      card.addEventListener('mouseenter', () => setClassicHot(zone.id, true));
      card.addEventListener('mouseleave', () => setClassicHot(zone.id, false));
      card.addEventListener('focus', () => setClassicHot(zone.id, true));
      card.addEventListener('blur', () => setClassicHot(zone.id, false));
      card.addEventListener('click', () => selectClassicZone(zone));
      els.legend.appendChild(card);
    });
    if (els.accessories && els.accessoriesGrid) {
      els.accessoriesGrid.innerHTML = '';
      const accessories = car.accessories || [];
      const renderedCar = state.classicCar;
      els.accessories.hidden = true;
      Promise.all(accessories.map(async (accessory) => {
        const product = await fetchClassicProduct(accessory.handle);
        if (!product || state.classicCar !== renderedCar) return null;
        const card = document.createElement('a');
        card.className = 'es__accessory-card';
        card.href = `${localePrefix}/products/${accessory.handle}`;
        const image = classicProductImage(product);
        card.innerHTML = `
          <span class="es__accessory-media">${image ? `<img src="${image}" alt="${product.title}" loading="lazy">` : '<i>SCART</i>'}</span>
          <span class="es__accessory-badge">${accessory.category || t('Accessoire', 'Accessory')}</span>
          <strong>${accessory.title}</strong>
          <p>${accessory.description || ''}</p>
          <b>${formatClassicMoney(product.price)}</b>`;
        return card;
      })).then((cards) => {
        if (state.classicCar !== renderedCar) return;
        cards.filter(Boolean).forEach((card) => els.accessoriesGrid.appendChild(card));
        els.accessories.hidden = !els.accessoriesGrid.children.length;
      });
    }
    setClassicQuery(state.classicCar);
    updateBreadcrumb();
  }

  function normalizeClassicProduct(item) {
    return typeof item === 'string' ? { h: item, f: [] } : item;
  }

  function fetchClassicProduct(handle) {
    if (classicProductCache.has(handle)) return classicProductCache.get(handle);
    const promise = fetch(`${localePrefix}/products/${encodeURIComponent(handle)}.js`, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then((response) => {
      if (!response.ok) throw new Error(`Product ${handle}: ${response.status}`);
      return response.json();
    }).catch(() => null);
    classicProductCache.set(handle, promise);
    return promise;
  }

  function formatClassicMoney(cents) {
    const amount = Number(cents || 0) / 100;
    const locale = document.documentElement.lang || (isFr ? 'fr-FR' : 'en-GB');
    const currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active : 'EUR';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency, maximumFractionDigits: 0 }).format(amount);
    } catch (e) {
      return `${amount.toFixed(0)} ${currency}`;
    }
  }

  function classicProductImage(product) {
    return product.featured_image || (product.images && product.images[0]) || '';
  }

  function createClassicProductCard(entry, choice) {
    const product = entry.product;
    const link = document.createElement('a');
    const image = classicProductImage(product);
    link.className = choice ? 'es__classic-choice es__card' : 'es__classic-product';
    link.href = `${localePrefix}/products/${entry.config.h}`;
    if (!product.available) link.classList.add('is-unavailable');
    if (choice) {
      const rangeLabels = {
        standard: t('Standard', 'Standard'),
        sport: 'Sport',
        racing: 'Racing'
      };
      const choiceLabel = entry.config.l || rangeLabels[entry.config.r] || product.title;
      link.setAttribute('aria-label', `${choiceLabel} — ${product.title} — ${formatClassicMoney(product.price)}`);
      link.innerHTML = `
        <span class="es__classic-choice-media">${image ? `<img src="${image}" alt="${product.title}" loading="lazy">` : ''}</span>
        <strong>${choiceLabel}</strong>
        <b>${formatClassicMoney(product.price)}</b>`;
    } else {
      link.innerHTML = `
        <span class="es__classic-product-media">${image ? `<img src="${image}" alt="${product.title}" loading="lazy">` : '<i>SCART</i>'}</span>
        <span class="es__classic-product-copy"><strong>${entry.config.l || product.title}</strong><b>${formatClassicMoney(product.price)}</b>${product.available ? '' : `<small>${t('Indisponible','Unavailable')}</small>`}</span>`;
    }
    link.addEventListener('click', () => trackEvent('configurator_product_click', {
      flow: 'classic',
      car: state.classicCar,
      zone: state.classicZone ? state.classicZone.id : '',
      product_handle: entry.config.h
    }));
    return link;
  }

  function appendClassicScale(host, labels) {
    if (!labels || labels.length < 2) return;
    const scale = document.createElement('p');
    scale.className = 'es__classic-scale';
    scale.setAttribute('aria-hidden', 'true');
    labels.forEach((label, index) => {
      const span = document.createElement('span');
      span.textContent = label;
      scale.appendChild(span);
      if (index < labels.length - 1) scale.appendChild(document.createElement('i'));
    });
    host.appendChild(scale);
  }

  function appendClassicProductGrid(host, entries, label) {
    if (!entries.length) return;
    const section = document.createElement('section');
    const grid = document.createElement('div');
    section.className = 'es__classic-alternatives';
    grid.className = 'es__classic-product-grid';
    if (label) {
      const heading = document.createElement('h4');
      heading.textContent = label;
      section.appendChild(heading);
    }
    entries.forEach((entry) => grid.appendChild(createClassicProductCard(entry, false)));
    section.appendChild(grid);
    host.appendChild(section);
  }

  function renderClassicRange(entries, scaleLabels) {
    const els = classicElements();
    const journey = document.createElement('div');
    const heading = document.createElement('p');
    const row = document.createElement('div');
    journey.className = 'es__classic-journey';
    heading.className = 'es__classic-journey-head';
    heading.innerHTML = `<strong>${state.classicZone.journeyTitle || t('La même pièce, plusieurs versions','The same part, several versions')}</strong><span>${state.classicZone.journeyHint || ''}</span>`;
    row.className = 'es__classic-choice-row';
    row.style.setProperty('--choice-count', Math.min(entries.length, 3));
    entries.slice().sort((a, b) => Number(a.config.s || 0) - Number(b.config.s || 0))
      .forEach((entry) => row.appendChild(createClassicProductCard(entry, true)));
    journey.appendChild(heading);
    journey.appendChild(row);
    appendClassicScale(journey, scaleLabels || [t('Proche de l’origine','Close to stock'), t('Le plus radical','Most radical')]);
    if (state.classicZone && state.classicZone.warning) {
      const warning = document.createElement('p');
      warning.className = 'es__classic-warning';
      warning.textContent = state.classicZone.warning;
      journey.appendChild(warning);
    }
    els.products.appendChild(journey);
  }

  function classicMatchesFilter(entry) {
    if (!state.classicZone || !state.classicZone.filter) return true;
    if (!state.classicFilter) return false;
    return (entry.config.f || []).includes(state.classicFilter);
  }

  function renderClassicProducts() {
    const els = classicElements();
    els.products.innerHTML = '';
    if (state.classicZone && state.classicZone.filter && !state.classicFilter) {
      els.count.textContent = t('Choisissez une option pour voir les références.', 'Choose an option to see the products.');
      return;
    }
    const visible = (state.classicZoneProducts || []).filter((entry) => entry.product && classicMatchesFilter(entry));
    els.count.textContent = `${visible.length} ${visible.length === 1 ? t('produit','product') : t('produits','products')}`;
    const sound = visible.filter((entry) => entry.config.g === 'sound');
    const hasSoundScale = sound.length > 1;
    const hasProductRange = !hasSoundScale && visible.length > 1 && visible.every((entry) => Boolean(entry.config.r));
    trackEvent('configurator_result', {
      flow: 'classic', car: state.classicCar, zone: state.classicZone && state.classicZone.id,
      has_match: visible.length > 0, match_count: visible.length,
      render: !visible.length ? 'empty' : hasSoundScale ? 'sound_scale' : hasProductRange ? 'range' : 'list',
      top_product_handle: visible.length ? visible[0].config.h : ''
    });
    if (!visible.length) {
      els.products.innerHTML = `<p class="es__empty">${t('Aucune référence disponible pour ce choix.','No product available for this selection.')}</p>`;
      return;
    }
    if (sound.length > 1) {
      renderClassicRange(sound, state.classicZone.scale || [t('Discret','Quiet'), t('Sonore','Loud')]);
      appendClassicProductGrid(els.products, visible.filter((entry) => entry.config.g === 'catalyst'), t('Avec catalyseur','With catalytic converter'));
      appendClassicProductGrid(els.products, visible.filter((entry) => entry.config.g === 'valve'), t('Avec valves','With valves'));
      appendClassicProductGrid(els.products, visible.filter((entry) => !entry.config.g), state.classicZone.otherLabel || '');
      return;
    }
    if (visible.length > 1 && visible.every((entry) => Boolean(entry.config.r))) {
      renderClassicRange(visible, state.classicZone.scale);
      return;
    }
    appendClassicProductGrid(els.products, visible, '');
  }

  function renderClassicFilter(zone) {
    const els = classicElements();
    els.filters.innerHTML = '';
    if (!zone.filter) return;
    const label = document.createElement('p');
    const options = document.createElement('div');
    label.className = 'es__classic-filter-label';
    label.textContent = zone.filter.label;
    options.className = 'es__classic-filter-options';
    zone.filter.options.forEach((option) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'es__classic-filter';
      button.textContent = option.l;
      button.addEventListener('click', () => {
        state.classicFilter = option.id;
        options.querySelectorAll('button').forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        renderClassicProducts();
        trackEvent('configurator_select', { flow: 'classic', step: 'filter', value: option.id, car: state.classicCar, zone: zone.id });
      });
      options.appendChild(button);
    });
    els.filters.appendChild(label);
    els.filters.appendChild(options);
  }

  function selectClassicZone(zone) {
    const els = classicElements();
    state.classicZone = zone;
    state.classicFilter = null;
    state.classicZoneProducts = [];
    root.querySelectorAll('[data-classic-zone]').forEach((item) => {
      item.classList.toggle('is-selected', item.dataset.classicZone === zone.id);
    });
    els.resultsTitle.textContent = zone.n;
    els.resultsDescription.textContent = zone.d;
    els.results.hidden = false;
    els.count.textContent = zone.filter
      ? t('Choisissez une option pour voir les références.', 'Choose an option to see the products.')
      : t('Chargement…', 'Loading…');
    els.products.innerHTML = '';
    renderClassicFilter(zone);
    updateBreadcrumb();
    const configs = zone.products.map(normalizeClassicProduct);
    Promise.all(configs.map((config) => fetchClassicProduct(config.h).then((product) => ({ config, product }))))
      .then((loaded) => {
        if (state.classicZone !== zone) return;
        state.classicZoneProducts = loaded;
        renderClassicProducts();
      });
    trackEvent('configurator_select', { flow: 'classic', step: 'piece', value: zone.id, car: state.classicCar });
  }

  function closeClassicResults() {
    const els = classicElements();
    state.classicZone = null;
    state.classicFilter = null;
    state.classicZoneProducts = [];
    if (els.results) els.results.hidden = true;
    root.querySelectorAll('[data-classic-zone]').forEach((item) => item.classList.remove('is-selected', 'is-hot'));
    if (state.classicFamily) updateBreadcrumb();
  }

  const classicClose = root.querySelector('[data-classic-close]');
  if (classicClose) classicClose.addEventListener('click', closeClassicResults);

  // === Product attributes detection (title only) ===
  // Description is too noisy (Scart descriptions often mention "valves" as
  // general context, not as the product's attribute). The post-10/05/2026
  // title convention is reliable: "Type - Marque Modèle (Génération)" with
  // gamme keywords (Sport/Super Sound/Riva/Ultima) and "à valves" when present.
  function productTitle(prod) {
    return (typeof prod === 'string' ? prod : (prod.title || '')).toLowerCase();
  }
  function detectGamme(prod) {
    const t = productTitle(prod);
    if (t.includes('riva')) return 'riva';
    if (t.includes('ultima')) return 'ultima';
    if (t.includes('super sound')) return 'super_sound';
    if (t.includes('sport')) return 'sport';
    return null;
  }
  function hasValves(prod) { return /\bvalves?\b/.test(productTitle(prod)); }

  function gammeLabel(g) {
    if (g === 'riva') return 'Riva';
    if (g === 'ultima') return 'Ultima';
    if (g === 'super_sound') return 'Super Sound';
    if (g === 'sport') return 'Sport';
    return '';
  }

  // === Scoring ===
  const ADJ = {
    sport:       { sport: 100, super_sound: 35, riva: 20, ultima: 20 },
    super_sound: { super_sound: 100, riva: 70, ultima: 70, sport: 30 },
    riva:        { riva: 100, ultima: 55, super_sound: 65, sport: 8 },
    ultima:      { ultima: 100, riva: 55, super_sound: 65, sport: 8 }
  };

  function targetGamme() {
    if (state.sound === 'sport') return 'sport';
    // Super Sound: deduce from generation (Riva for old, Ultima for recent)
    if (state.generation && RIVA_GENS.has(state.generation)) return 'riva';
    return 'ultima';
  }

  function scoreOne(prod, target, valvesPref) {
    let s = 0;
    const gamme = detectGamme(prod.title);
    const valves = hasValves(prod.title);
    if (gamme) s += ADJ[target] ? (ADJ[target][gamme] || 0) : 0;
    else if (valves) s += 20;
    if (valvesPref === 'oui') s += valves ? 40 : -200;
    else if (valvesPref === 'non') s += valves ? -200 : 30;
    else s += 5;
    if (prod.available !== false) s += 3;
    return s;
  }

  // === Result fetching ===
  async function fetchCollectionProducts(handle) {
    const url = `${localePrefix}/collections/${handle}/products.json?limit=250`;
    const r = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
    if (!r.ok) throw new Error('collection fetch HTTP ' + r.status);
    const j = await r.json();
    return j.products || [];
  }

  // Cache of products for the currently-selected leaf collection (model or generation).
  // Used to gray out unavailable options on the sound/valves screens.
  let leafCache = { handle: null, products: null, availability: null };

  function computeAvailability(products) {
    let withValves = 0, withoutValves = 0;
    let hasSport = false, hasSuperSound = false;
    for (const p of products) {
      if (hasValves(p)) withValves++;
      else withoutValves++;
      const g = detectGamme(p);
      if (g === 'sport') hasSport = true;
      if (g === 'super_sound' || g === 'riva' || g === 'ultima') hasSuperSound = true;
    }
    return { withValves, withoutValves, hasSport, hasSuperSound, total: products.length };
  }

  async function preloadLeafCollection() {
    const leafHandle = state.generation || state.model;
    if (!leafHandle) return;
    if (leafCache.handle === leafHandle && leafCache.products) return; // already cached
    leafCache = { handle: leafHandle, products: null, availability: null };
    try {
      const products = await fetchCollectionProducts(leafHandle);
      leafCache.products = products;
      leafCache.availability = computeAvailability(products);
    } catch (e) {
      console.error('[es] preload failed', e);
    }
  }

  // Update the Super Sound card kicker + copy based on the selected
  // Porsche generation/model. Riva for older (≤993, classic models),
  // Ultima for recent (996+, Boxster, etc). Other brands keep the generic copy.
  function updateSoundLabels() {
    const ssCard = root.querySelector('[data-pick="sound"][data-value="super_sound"]');
    if (!ssCard) return;
    const kickerEl = ssCard.querySelector('.es__card-kicker');
    const copyEl = ssCard.querySelector('.es__card-copy');
    if (!kickerEl || !copyEl) return;

    let variant = null;
    if (state.brand === 'porsche') {
      const leaf = state.generation || state.model;
      if (leaf) variant = RIVA_GENS.has(leaf) ? 'riva' : 'ultima';
    }

    if (variant === 'riva') {
      kickerEl.textContent = t('Le sommet · Riva', 'The peak · Riva');
      copyEl.textContent = t(
        'Profond, guttural - héritage des 911 anciennes.',
        'Deep, guttural - heritage of vintage 911s.'
      );
    } else if (variant === 'ultima') {
      kickerEl.textContent = t('Le sommet · Ultima', 'The peak · Ultima');
      copyEl.textContent = t(
        'Double son sans pièce mobile. Zéro laine de roche.',
        'Twin-tone without moving parts. Zero rockwool.'
      );
    } else {
      kickerEl.textContent = t('Le sommet', 'The peak');
      copyEl.textContent = t(
        'Notre signature pleine. Profondeur, puissance, texture acoustique.',
        'Our full signature. Depth, power, acoustic texture.'
      );
    }
  }

  function applyAvailability() {
    const avail = leafCache.availability;
    if (!avail) return;
    const label = t('Non disponible', 'Not available');
    function setStatus(card, unavail) {
      if (!card) return;
      if (unavail) {
        card.classList.add('is-unavailable');
        card.setAttribute('data-unavailable-label', label);
        card.setAttribute('aria-disabled', 'true');
      } else {
        card.classList.remove('is-unavailable');
        card.removeAttribute('data-unavailable-label');
        card.removeAttribute('aria-disabled');
      }
    }
    setStatus(root.querySelector('[data-pick="sound"][data-value="sport"]'), !avail.hasSport);
    setStatus(root.querySelector('[data-pick="sound"][data-value="super_sound"]'), !avail.hasSuperSound);
    setStatus(root.querySelector('[data-pick="valves"][data-value="oui"]'), avail.withValves === 0);
    setStatus(root.querySelector('[data-pick="valves"][data-value="non"]'), avail.withoutValves === 0);
  }

  function formatPrice(s) {
    if (!s) return '';
    const n = parseFloat(s);
    if (isNaN(n)) return '';
    return t('À partir de ', 'From ') + new Intl.NumberFormat(isFr ? 'fr-FR' : 'en-US', {
      style: 'currency', currency: 'EUR', maximumFractionDigits: 0
    }).format(n);
  }

  function renderProductCard(prod, container, slot) {
    const tmpl = document.getElementById('es-tmpl-product');
    const node = tmpl.content.firstElementChild.cloneNode(true);
    node.href = `${localePrefix}/products/${prod.handle}`;
    const img = node.querySelector('img');
    const src = (prod.images && prod.images[0] && (prod.images[0].src || prod.images[0])) || null;
    if (src) { img.src = src; img.alt = prod.title; }
    else img.remove();
    const gamme = detectGamme(prod.title);
    const valves = hasValves(prod.title);
    node.querySelector('.es__product-gamme').textContent =
      [gammeLabel(gamme), valves ? t('À valves', 'With valves') : null].filter(Boolean).join(' · ');
    node.querySelector('.es__product-title').textContent = prod.title;
    const brand = findBrand(state.brand);
    const model = findModel(state.brand, state.model);
    const gen = findGen(state.brand, state.model, state.generation);
    node.querySelector('.es__product-meta').textContent =
      [brand?.label, model?.label, gen ? `(${gen.label})` : ''].filter(Boolean).join(' · ');
    const price = prod.variants && prod.variants[0] ? prod.variants[0].price : null;
    node.querySelector('.es__product-price').textContent = formatPrice(price);
    node.querySelector('.es__product-cta').textContent = t('Voir le produit →', 'See product →');
    node.addEventListener('click', () => {
      trackEvent('configurator_product_click', {
        product_handle: prod.handle,
        product_title: prod.title,
        slot: slot || 'main',
        brand: state.brand, model: state.model, generation: state.generation, sound: state.sound, valves: state.valves
      });
    });
    container.appendChild(node);
  }

  async function renderResult() {
    const screen = $screen('result');
    const wrapEl = screen.querySelector('[data-result]');
    const loadEl = screen.querySelector('[data-loading="result"]');
    if (loadEl) loadEl.hidden = false;

    // Use cached products if available, else fetch
    const leafHandle = state.generation || state.model;
    let products = [];
    if (leafCache.handle === leafHandle && leafCache.products) {
      products = leafCache.products;
    } else {
      try {
        products = await fetchCollectionProducts(leafHandle);
      } catch (err) {
        console.error('[es] fetch failed', err);
      }
    }

    if (loadEl) loadEl.remove();
    wrapEl.innerHTML = '';
    const node = document.getElementById('es-tmpl-result').content.firstElementChild.cloneNode(true);

    const target = targetGamme();
    if (state.piece) {
      const isPre = t => /pr[ée]-?\s?silencieux|pre-?\s?muffler/i.test(t || '');
      products = state.piece === 'presilencieux'
        ? products.filter(p => isPre(p.title))
        : products.filter(p => !isPre(p.title));
    }
    const valvesStrict = state.valves !== 'peu_importe';
    const wantsValves = state.valves === 'oui';

    // First pass: strict filter on valves preference
    let scored = [];
    let valvesMismatch = false;

    if (valvesStrict) {
      const strictPool = products.filter(p => hasValves(p.title) === wantsValves);
      scored = strictPool
        .map(p => ({ prod: p, score: scoreOne(p, target, state.valves) }))
        .filter(x => x.score > 0)
        .sort((a, b) => b.score - a.score);
      if (!scored.length && products.length) {
        // No strict match - fallback to whatever exists, flag the mismatch
        valvesMismatch = true;
        scored = products
          .map(p => ({ prod: p, score: scoreOne(p, target, 'peu_importe') }))
          .filter(x => x.score > 0)
          .sort((a, b) => b.score - a.score);
      }
    } else {
      scored = products
        .map(p => ({ prod: p, score: scoreOne(p, target, state.valves) }))
        .filter(x => x.score > 0)
        .sort((a, b) => b.score - a.score);
    }

    let main = scored[0]?.prod || null;
    if (state.pickedHandle) {
      const picked = products.find(p => p.handle === state.pickedHandle);
      if (picked) {
        main = picked;
        scored = [{ prod: picked, score: 999 }].concat(scored.filter(x => x.prod.handle !== picked.handle));
      }
    }
    const alts = scored.slice(1, 3).map(x => x.prod);

    const brand = findBrand(state.brand);
    const model = findModel(state.brand, state.model);
    const gen = findGen(state.brand, state.model, state.generation);
    const vehicleLabel = [brand?.label, model?.label, gen ? `(${gen.label})` : ''].filter(Boolean).join(' ');

    const summary = node.querySelector('.es__result-summary');
    const mainEl = node.querySelector('.es__result-main');
    const altsWrap = node.querySelector('.es__result-alts');
    const altsList = node.querySelector('.es__result-alts-list');
    const altsLabel = node.querySelector('.es__result-alts-label');
    const emptyEl = node.querySelector('.es__result-empty');

    altsLabel.textContent = t('Alternatives proches', 'Close alternatives');

    if (!main) {
      // No catalogue match - pivot to bespoke / custom-build conversation.
      summary.remove();
      mainEl.remove();
      altsWrap.remove();
      emptyEl.hidden = false;

      const soundLabel = state.sound === 'super_sound'
        ? t('Super Sound', 'Super Sound')
        : state.sound === 'sport'
          ? t('Sport', 'Sport')
          : t('À définir', 'To define');
      const valvesLabel = state.valves === 'oui'
        ? t('Avec valves', 'With valves')
        : state.valves === 'non'
          ? t('Sans valves', 'Without valves')
          : t('Indifférent', 'No preference');

      emptyEl.querySelector('.es__custom-eyebrow').textContent = t('Sur-mesure', 'Bespoke');
      emptyEl.querySelector('.es__custom-title').textContent = t(
        'Votre configuration sort du catalogue.',
        'Your configuration is off-catalogue.'
      );
      emptyEl.querySelector('.es__custom-lede').textContent = t(
        "Tant mieux. L'atelier de Goussainville fabrique régulièrement sur demande - soudage TIG, cintrage et ajustage chez nous. Décrivez-nous votre projet, on revient vers vous sous 24 h.",
        "Good news. Our Goussainville workshop builds to order on a regular basis - TIG welding, bending and fitting done in-house. Describe your project and we'll come back to you within 24 hours."
      );

      const recap = emptyEl.querySelector('.es__custom-recap');
      const recapRows = [
        [t('Véhicule', 'Vehicle'), [brand?.label, model?.label].filter(Boolean).join(' ') || '-'],
        [t('Génération', 'Generation'), gen?.label || t('Non précisée', 'Unspecified')],
        [t('Son', 'Sound'), soundLabel],
        [t('Valves', 'Valves'), valvesLabel]
      ];
      recap.innerHTML = recapRows.map(([k, v]) =>
        `<li><span class="es__custom-recap-key">${k}</span><span class="es__custom-recap-val">${v}</span></li>`
      ).join('');

      const projectLine = t(
        `${vehicleLabel || 'Véhicule à préciser'} - ${soundLabel}, ${valvesLabel.toLowerCase()}`,
        `${vehicleLabel || 'Vehicle TBD'} - ${soundLabel}, ${valvesLabel.toLowerCase()}`
      );
      const waMsg = t(
        `Bonjour Scart 👋\n\nJe cherche un échappement pour ma ${vehicleLabel || 'voiture'}.\nPréférences : ${soundLabel}, ${valvesLabel.toLowerCase()}.\n\nPas de produit catalogue exact - possible en sur-mesure ?`,
        `Hi Scart 👋\n\nI'm looking for an exhaust for my ${vehicleLabel || 'car'}.\nPreferences: ${soundLabel}, ${valvesLabel.toLowerCase()}.\n\nNo exact catalogue product - would a bespoke build be possible?`
      );
      const mailSubject = t(
        `Demande sur-mesure - ${vehicleLabel || 'Véhicule à préciser'}`,
        `Bespoke request - ${vehicleLabel || 'Vehicle TBD'}`
      );

      const waCard = emptyEl.querySelector('.es__custom-card--whatsapp');
      waCard.href = 'https://wa.me/33619735074?text=' + encodeURIComponent(waMsg);
      waCard.querySelector('.es__custom-card-eyebrow').textContent = projectLine;
      waCard.querySelector('.es__custom-card-cta').innerHTML =
        t('Démarrer la conversation', 'Start the conversation') + ' <span aria-hidden="true">→</span>';
      waCard.addEventListener('click', () => {
        const payload = { channel: 'whatsapp', brand: state.brand, model: state.model, generation: state.generation, sound: state.sound, valves: state.valves };
        if (window.gtag) window.gtag('event', 'custom_request_whatsapp', payload);
        if (window.dataLayer) window.dataLayer.push(Object.assign({ event: 'custom_request_whatsapp' }, payload));
      });

      // Desktop: reveal the inline Shopify contact form and pre-fill the textarea
      const formWrap = root.querySelector('[data-custom-form-wrap]');
      if (formWrap) {
        const textarea = formWrap.querySelector('[data-custom-body]');
        if (textarea && !textarea.value.trim()) {
          textarea.value = waMsg;
        }
        formWrap.classList.add('is-active');
        const submitBtn = formWrap.querySelector('button[type="submit"]');
        if (submitBtn && !submitBtn.dataset.esTracked) {
          submitBtn.dataset.esTracked = '1';
          submitBtn.addEventListener('click', () => {
            const payload = { channel: 'form', brand: state.brand, model: state.model, generation: state.generation, sound: state.sound, valves: state.valves };
            if (window.gtag) window.gtag('event', 'custom_request_form', payload);
            if (window.dataLayer) window.dataLayer.push(Object.assign({ event: 'custom_request_form' }, payload));
          });
        }
      }

      trackEvent('configurator_result', {
        has_match: false,
        brand: state.brand, model: state.model, generation: state.generation, sound: state.sound, valves: state.valves
      });
      if (window.gtag) window.gtag('event', 'custom_request_open', { brand: state.brand, model: state.model, generation: state.generation, sound: state.sound, valves: state.valves });
      if (window.dataLayer) window.dataLayer.push({ event: 'custom_request_open', brand: state.brand, model: state.model, generation: state.generation, sound: state.sound, valves: state.valves });
    } else {
      // Hide the inline custom form when we have a catalogue match
      const formWrap = root.querySelector('[data-custom-form-wrap]');
      if (formWrap) formWrap.classList.remove('is-active');
      emptyEl.remove();
      const mainGamme = detectGamme(main.title);
      const gammeMismatch = target && mainGamme && target !== mainGamme;

      let summaryText;
      if (valvesMismatch) {
        summaryText = t(
          `Pas de version ${wantsValves ? 'à valves' : 'sans valves'} pour votre ${vehicleLabel} au catalogue. Voici la meilleure alternative ${wantsValves ? 'sans valves' : 'à valves'}.`,
          `No ${wantsValves ? 'valve' : 'non-valve'} version for your ${vehicleLabel} in catalogue. Here's the closest match ${wantsValves ? 'without valves' : 'with valves'}.`
        );
      } else if (gammeMismatch) {
        summaryText = t(
          `Pour votre ${vehicleLabel}, nous n'avons pas exactement un ${gammeLabel(target)} - voici la meilleure alternative dans la même philosophie.`,
          `For your ${vehicleLabel}, we don't have an exact ${gammeLabel(target)} - here's the closest match.`
        );
      } else {
        summaryText = t(
          `Pour votre ${vehicleLabel} - voici notre recommandation.`,
          `For your ${vehicleLabel} - here's our recommendation.`
        );
      }
      summary.textContent = summaryText;

      renderProductCard(main, mainEl, 'main');
      if (alts.length) {
        altsWrap.hidden = false;
        for (const a of alts) renderProductCard(a, altsList, 'alternative');
      } else {
        altsWrap.remove();
      }
      trackEvent('configurator_result', {
        has_match: true,
        match_count: scored.length,
        valves_mismatch: !!valvesMismatch,
        top_product_handle: main.handle,
        brand: state.brand, model: state.model, generation: state.generation, sound: state.sound, valves: state.valves
      });
    }

    const restartBtn = node.querySelector('[data-action="restart"]');
    restartBtn.querySelector('span').textContent = t('Recommencer', 'Start over');
    restartBtn.addEventListener('click', restart);

    const link = node.querySelector('[data-result-link]');
    link.href = `${localePrefix}/pages/notre-gamme`;
    link.textContent = t('En savoir plus sur la gamme →', 'Learn about the range →');

    wrapEl.appendChild(node);
  }

  // === Events ===
  root.addEventListener('click', (e) => {
    const restartBtn = e.target.closest('[data-action="restart"]');
    if (restartBtn) { restart(); return; }

    const card = e.target.closest('[data-pick]');
    if (!card) return;
    const pick = card.dataset.pick;
    const value = card.dataset.value;

    if (card.classList.contains('is-unavailable')) {
      return; // don't react to disabled cards
    }

    card.classList.add('is-picked');

    if (pick === 'brand') {
      state.brand = value;
      state.model = null;
      state.generation = null;
      state.classicFamily = null;
      state.classicCar = null;
      transitionTo('model', { direction: 'forward', beforeShow: renderModelGrid });
    } else if (pick === 'model') {
      state.model = value;
      state.generation = null;
      state.classicFamily = null;
      state.classicCar = null;
      const m = findModel(state.brand, state.model);
      if (m && m.generations && m.generations.length) {
        transitionTo('generation', { direction: 'forward', beforeShow: renderGenerationGrid });
      } else if (activatePublishedSelection(state.brand, state.model, null)) {
        return;
      } else {
        // Leaf is model: preload + transition to sound, then mark unavailable cards
        updateSoundLabels();
        transitionTo('sound', { direction: 'forward' });
        preloadLeafCollection().then(applyAvailability);
      }
    } else if (pick === 'classic-family') {
      state.classicFamily = value;
      state.classicCar = null;
      state.classicZone = null;
      state.generation = null;
      setClassicQuery('');
      transitionTo('classic-version', { direction: 'forward', beforeShow: renderClassicVersionGrid });
    } else if (pick === 'classic-version') {
      const version = classicVersion(value);
      if (!version) return;
      if (version.familyId) {
        selectPublishedVersion(version);
        return;
      }
      state.classicCar = value;
      state.classicZone = null;
      state.generation = version.collection;
      transitionTo('piece', { direction: 'forward', beforeShow: renderClassicCar });
    } else if (pick === 'generation') {
      state.generation = value;
      state.classicFamily = null;
      state.classicCar = null;
      setClassicQuery('');
      if (!activatePublishedSelection(state.brand, state.model, value)) {
        updateSoundLabels();
        transitionTo(isTypeG() ? 'piece' : 'sound', { direction: 'forward' });
        preloadLeafCollection().then(applyAvailability);
      }
    } else if (pick === 'pse' && state.pendingPseChoice) {
      state.classicCar = value === 'oui'
        ? state.pendingPseChoice.withPse
        : state.pendingPseChoice.withoutPse;
      state.pendingPseChoice = null;
      state.classicZone = null;
      transitionTo('piece', { direction: 'forward', beforeShow: renderClassicCar });
    } else if (pick === 'sound') {
      state.sound = value;
      /* sur les cartes-pieces le client designe UNE reference : sans ca, deux pieces
         de meme categorie sonore (Riva et Racing sont toutes deux "super_sound")
         se confondent et le matcher renvoie l'autre. */
      state.pickedHandle = card.dataset.handle || null;
      if (isTypeG()) { transitionTo('result', { direction: 'forward', beforeShow: renderResult }); }
      else { transitionTo('valves', { direction: 'forward' }); applyAvailability(); }
    } else if (pick === 'valves') {
      state.valves = value;
      if (isTypeG() && value !== 'oui') { transitionTo('sound', { direction: 'forward' }); applyAvailability(); }
      else { transitionTo('result', { direction: 'forward', beforeShow: renderResult }); }
    } else if (pick === 'piece' && !isClassic()) {
      state.piece = value;
      state.pieceLabel = card.dataset.label || value;
      updateBreadcrumb();
      transitionTo('valves', { direction: 'forward' });
      applyAvailability();
    }
    const selection = { step: pick, value: value };
    if (pick === 'classic-family' || pick === 'classic-version' || pick === 'pse') selection.flow = 'classic';
    trackEvent('configurator_select', selection);
  });

  // === Init ===
  renderBrandGrid();
  root.classList.toggle('is-in-journey', activeScreen !== 'brand');

  // Prefill from URL ?collection=<handle> - used when user enters from a collection or PDP.
  // We walk TREE to find which brand/model/generation the handle corresponds to,
  // then replay the appropriate selections to skip ahead.
  function findPathByHandle(handle) {
    if (handle === '911-2-7l-3-0l-type-g') return { brand: 'porsche', model: '911', classicFamily: 'classic-type-g', classicCar: 'type-g-27-30' };
    if (handle === '911-type-g') return { brand: 'porsche', model: '911', classicFamily: 'classic-type-g', classicCar: 'type-g-32' };
    if (handle === '930') return { brand: 'porsche', model: '911', classicFamily: 'classic-type-g', classicCar: '930' };
    if (handle === '964') return { brand: 'porsche', model: '911', classicFamily: 'classic-964' };
    if (handle === '993') return { brand: 'porsche', model: '911', classicFamily: 'classic-993' };
    for (const brand of TREE.brands) {
      if (brand.handle === handle) return { brand: brand.handle };
      for (const model of (brand.models || [])) {
        if (model.handle === handle) return { brand: brand.handle, model: model.handle, modelHasGens: !!(model.generations && model.generations.length) };
        for (const gen of (model.generations || [])) {
          if (gen.handle === handle) return { brand: brand.handle, model: model.handle, generation: gen.handle };
        }
      }
    }
    return null;
  }

  function pickDeepestPath(handles) {
    // Among multiple handles, prefer the one that resolves deepest in the tree
    // (generation > model > brand). Order: by path depth desc.
    const paths = handles.map(h => ({ h, path: findPathByHandle(h) })).filter(x => x.path);
    if (!paths.length) return null;
    paths.sort((a, b) => {
      const da = (a.path.classicCar ? 5 : 0) + (a.path.classicFamily ? 4 : 0) + (a.path.generation ? 3 : 0) + (a.path.model ? 2 : 0) + (a.path.brand ? 1 : 0);
      const db = (b.path.classicCar ? 5 : 0) + (b.path.classicFamily ? 4 : 0) + (b.path.generation ? 3 : 0) + (b.path.model ? 2 : 0) + (b.path.brand ? 1 : 0);
      return db - da;
    });
    return paths[0].path;
  }

  try {
    const params = new URL(window.location.href).searchParams;
    const colHandle = params.get('collection');
    const colsParam = params.get('collections');
    const carParam = params.get('car');
    let path = null;
    if (carParam && CLASSIC.cars[carParam]) {
      const familyEntry = Object.entries(CLASSIC.families).find((entry) => entry[1].versions.some((version) => version.id === carParam));
      if (familyEntry) path = { brand: 'porsche', model: '911', classicFamily: familyEntry[0], classicCar: carParam };
      else {
        const vehicle = publicVehicle(carParam);
        if (vehicle && PRODUCTION_FAMILY_IDS.has(vehicle.visualFamilyId)) {
          const version = familyVersion(vehicle.visualFamilyId);
          const groupId = `published:${vehicleBrandHandle(vehicle)}:${vehicle.modelId}:${vehicle.generationId || 'model'}`;
          CLASSIC.families[groupId] = { label: vehicle.generationLabel || vehicle.model, versions: version ? [version] : [] };
          path = {
            brand: vehicleBrandHandle(vehicle),
            model: vehicle.modelId,
            generation: vehicle.generationId,
            classicFamily: groupId,
            classicCar: carParam
          };
        }
      }
    } else if (colsParam) {
      const handles = colsParam.split(',').map(s => s.trim()).filter(Boolean);
      path = pickDeepestPath(handles);
    } else if (colHandle) {
      path = findPathByHandle(colHandle);
    }
    if (path) {
      state.brand = path.brand;
      if (path.model) state.model = path.model;
      if (path.generation) state.generation = path.generation;
      if (path.classicFamily) state.classicFamily = path.classicFamily;
      if (path.classicCar) {
        const version = classicVersion(path.classicCar);
        state.classicCar = path.classicCar;
        state.generation = version ? version.collection : null;
      }

      if (path.classicCar) {
        transitionTo('piece', { immediate: true });
        renderClassicCar();
      } else if (path.classicFamily) {
        renderClassicVersionGrid();
        transitionTo('classic-version', { immediate: true });
      } else if (path.generation) {
        // Brand + model + gen known → jump to "sound" screen
        updateSoundLabels();
        transitionTo('sound', { immediate: true });
        preloadLeafCollection().then(applyAvailability);
      } else if (path.model) {
        // Brand + model known → if model has generations, ask for it; else jump to sound
        if (path.modelHasGens) {
          transitionTo('generation', { immediate: true });
          renderGenerationGrid();
        } else {
          updateSoundLabels();
          transitionTo('sound', { immediate: true });
          preloadLeafCollection().then(applyAvailability);
        }
      } else {
        // Brand only → next is model
        transitionTo('model', { immediate: true });
        renderModelGrid();
      }
      trackEvent('configurator_prefill', {
        from: carParam || colsParam || colHandle,
        brand: state.brand, model: state.model, generation: state.generation
      });
    }
  } catch (e) { /* prefill non-fatal */ }
})();
